import { Children, forwardRef } from 'react';

import { toTitleCase } from '~/common/util/format';

const uCaseChildren = (children) => {
  // eslint-disable-next-line @eslint-react/no-children-map
  return Children.map(children, (child) => {
    /* c8 ignore next */
    if (child) {
      /* c8 ignore next */
      if (typeof child === 'string') {
        return toTitleCase(child);
      } else if (Array.isArray(child)) {
        return uCaseChildren(child);
      } else if (typeof child === 'object') {
        return {
          ...child,
          props: {
            ...child.props,
            children: child.props.children
              ? uCaseChildren(child.props.children)
              : null,
          },
        };
      }
    }
  });
};

type TitleCaseProps = {
  children?: string | React.ReactNode | any[];
};

const TitleCaseUi = (Ui) => {
  const TitleCase = forwardRef<any, TitleCaseProps>(
    ({ children, ...props }, ref) => {
      return (
        <Ui {...props} ref={ref}>
          {uCaseChildren(children)}
        </Ui>
      );
    },
  );
  TitleCase.displayName = 'TitleCase';
  return TitleCase;
};

export default TitleCaseUi;
